export class Vehiculo2 {
  id: number;
  patente: any;
  descripcion: string;
  imei: any;
  estado: string;
  icon: Icon;
  iconDefaultUrl: string;
  point: Point;
  lastPoint: Point;
  color: string;
  clase: string;
  tipo: any;
  idGrupo: number;
  idClase: number;
  nombreGrupo: string;
  nombreFlota: string;
  selected: boolean;
  isOpenInfoWindow: boolean;
  temperatura: TemperaturaInputs;
  conductor: string;
  oemBatteryChargeStateTel: null | number;
  oemBatteryChargeLevelTel: null | number;
  obdEomTotalMileageTel: null | number;
  combustible: string;
  adcData: any[];
  /* PROYEC-816 desde req
   * 1 = Detenido
   * 2 = Encendido
   * 3 = Apagado
   * 4 = Online (ya no mapeado, cae al default)
   * 5 = Online Telemetria (ya no mapeado, cae al default)
   * 6 = N/A (hrs)
   * 7 = N/A (dias)
   * 8 = En Taller (ya no mapeado, cae al default)
   */
  colores = [
    '',
    'amarillo',
    'verde',
    'rojo',
    '',
    '',
    'gris',
    'gris',
    '',
  ];

  clases = [
    '',
    'color-detenido',
    'color-encendido',
    'color-apagado',
    '',
    '',
    'color-off',
    'color-off',
    ''
  ];

  estados = [
    '',
    'Detenido',
    'Encendido',
    'Apagado',
    '',
    '',
    'Offline',
    'Offline',
    ''
  ];


  constructor() {
  }
  
  // Método para clonar la instancia actual
  clone(): Vehiculo2 {
    const clone = new Vehiculo2();

    clone.id = this.id;
    clone.patente = this.patente;
    clone.descripcion = this.descripcion;
    clone.imei = this.imei;
    clone.estado = this.estado;
    clone.icon = this.icon;
    clone.iconDefaultUrl = this.iconDefaultUrl;
    clone.point = this.point ? new Point(this.point) : null;
    clone.lastPoint = this.lastPoint ? new Point(this.lastPoint) : null;
    clone.color = this.color;
    clone.clase = this.clase;
    clone.tipo = this.tipo;
    clone.idGrupo = this.idGrupo;
    clone.idClase = this.idClase;
    clone.nombreGrupo = this.nombreGrupo;
    clone.nombreFlota = this.nombreFlota;
    clone.selected = this.selected;
    clone.isOpenInfoWindow = this.isOpenInfoWindow;
    clone.temperatura = this.temperatura ? new TemperaturaInputs(this.temperatura) : null;
    clone.conductor = this.conductor;
    clone.oemBatteryChargeStateTel = this.oemBatteryChargeStateTel;
    clone.oemBatteryChargeLevelTel = this.oemBatteryChargeLevelTel;
    clone.obdEomTotalMileageTel = this.obdEomTotalMileageTel;
    clone.combustible = this.combustible;
    clone.adcData = this.adcData ? [...this.adcData] : null;

    return clone;
  }

  setData(data: any, selected = true, isOpenInfoWindow = false) {
    // Soporta tanto el formato legacy (/realtimedata/latest) como el nuevo (getlocalizacion)
    const rawDesc = data.desc !== undefined && data.desc !== null ? data.desc : data.descripcion;
    const descUpper = rawDesc ? String(rawDesc).toUpperCase().trim() : '';
    this.descripcion = (descUpper === '' || descUpper === 'N/A' || descUpper === 'N/D') ? '' : rawDesc;
    this.id = data.vehicleId !== undefined && data.vehicleId !== null ? data.vehicleId : (data.vehicleid !== undefined && data.vehicleid !== null ? data.vehicleid : null);
    this.patente = data.patente;
    this.imei = data.imei;
    this.tipo = data.icono !== undefined && data.icono !== null ? data.icono : 'auto';
    this.idGrupo = data.idGrupo !== undefined && data.idGrupo !== null ? data.idGrupo : null;
    this.idClase = data.idClase !== undefined && data.idClase !== null ? data.idClase : null;
    this.setPoint(data);
    this.selectColor(data);
    this.selected = selected;
    this.isOpenInfoWindow = isOpenInfoWindow;
    this.temperatura = new TemperaturaInputs(data);
    this.conductor = data.conductor;
    this.oemBatteryChargeStateTel = data.oemBatteryChargeStateTel;
    this.oemBatteryChargeLevelTel = data.oemBatteryChargeLevelTel;
    this.obdEomTotalMileageTel = data.obdEomTotalMileageTel;
    this.combustible = data.combustible;
    this.adcData = data.adcData && Array.isArray(data.adcData) ? data.adcData : null;
  }

  setPoint(data: any) {
    if (this.point) {
      this.lastPoint = this.point;
    }
    this.point = new Point(data);
  }

  selectColor(data: any) {
    // Si el nuevo formato no trae estado, se deriva de ign y sog
    const ign = data.ign !== undefined && data.ign !== null ? data.ign : data.ignicion;
    const sog = data.sog !== undefined && data.sog !== null ? data.sog : data.speed;
    const idestado = data.estado !== undefined && data.estado !== null ? data.estado : this.deriveEstado(ign, sog);
    if (idestado > 0 && this.colores[idestado]) {
      this.color = this.colores[idestado];
      this.estado = this.estados[idestado];
      this.clase = this.clases[idestado];
    } else {
      this.color = this.colores[6];
      this.estado = this.estados[6];
      this.clase = this.clases[6];
    }
    this.iconDefaultUrl = `./${this.tipo}-${this.color}.svg`;
  }

  private deriveEstado(ign: number, sog: number): number {
    if (ign === 1) return sog > 0 ? 2 : 1; // Encendido en movimiento / Detenido
    if (ign === 0) return 3;                // Apagado
    return 6;                               // Offline/sin dato
  }

  rotateImg(url: any, cog: number) {
    const canvas = document.createElement('canvas');
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.src = url;
    img.onload =  () => {
      const centerX = img.width / 2;
      const centerY = img.height / 2;
      const context = canvas.getContext('2d');
      canvas.width = img.height + 40;
      canvas.height = img.height + 40;
      context.save();
      context.translate(centerX, centerY);
      context.rotate(cog * Math.PI / 180);
      context.drawImage(img, -centerX, -centerY);
      context.restore();
      this.icon = {
        url: canvas.toDataURL('image/png'),
        scaledSize: new google.maps.Size(60, 60)
      };
    };
  }
}



class Point {
  sog: any;
  cog: any;
  lat: any;
  lng: any;
  old: any;
  ignition: any;
  millis: any;
  direccion: string;


  constructor(data: any) {
    // Soporta tanto el formato legacy (speed, ignicion, utc) como el nuevo (sog, ign, epoch)
    const rawSog = data.sog !== undefined && data.sog !== null ? data.sog : data.speed;
    this.sog = rawSog !== undefined && rawSog !== null ? rawSog : 0;
    this.cog = data.cog !== undefined && data.cog !== null ? data.cog : 0;
    this.lat = data.hasOwnProperty("lat") ? data.lat : data.latitud;
    this.lng = data.hasOwnProperty("lon") ? data.lon : data.longitud;
    this.old = data.old !== undefined && data.old !== null ? data.old : false;
    const rawIgn = data.ign !== undefined && data.ign !== null ? data.ign : data.ignicion;
    this.ignition = rawIgn !== undefined && rawIgn !== null ? rawIgn : -1;
    const rawEpoch = data.epoch !== undefined && data.epoch !== null ? data.epoch : null;
    this.millis = rawEpoch !== null ? rawEpoch : (data.hasOwnProperty("utc") ? data.utc : data.fechaEmision);
    this.direccion = '---';
  }
}

class TemperaturaInputs {
  isTemperatura: boolean;
  adc1: number;
  adc2: number;
  adc3: number;
  adc4: number;
  noT = -200;

  constructor(data: any) {
    this.adc1 = data.adc;
    this.adc2 = data.adc2;
    this.adc3 = data.adc3;
    this.adc4 = data.adc4;


    if (this.validacion(this.adc1) || this.validacion(this.adc2) || this.validacion(this.adc3) || this.validacion(this.adc4)) {
      this.isTemperatura = true;
    } else {
      this.isTemperatura = false;
    }
  }

  validacion(adc) {
    if ( adc !== this.noT && (adc > -200 && adc < 200)) {
      return true;
    } else {
      return false;
    }
  }

}

interface Icon {
  url: string;
  scaledSize: google.maps.Size;
}

